import React from 'react'
import Common_Banner from "../common-components/common-banner/Common_Banner";
import { Container, Row, Col } from "react-bootstrap";
import "./Gallery.css";


const Gallery = () => {
    const galleryImages = [
        { id: 1, src: './assets/images/gallery/img-1.png', alt: "Yoga Session" },
        { id: 2, src: './assets/images/gallery/img-2.png', alt: "weight-training" },
        { id: 3, src: './assets/images/gallery/img-3.png', alt: "Rugby" },
        { id: 4, src: './assets/images/gallery/img-4.png', alt: "Volleyball" },
        { id: 5, src: './assets/images/gallery/img-3.png', alt: "Rugby" },
        { id: 6, src: './assets/images/gallery/img-6.png', alt: "training" },
        { id: 7, src: './assets/images/gallery/img-7.png', alt: "pull-ups" },
        { id: 8, src: './assets/images/gallery/img-8.png', alt: "high-fi" },
        { id: 9, src: './assets/images/gallery/img-9.png', alt: "men" },
    ];
    const breadcrumbs = [
        { label: "Home", link: "/gallery", isActive: false },
        { label: "GALLERY", link: "", isActive: true },
    ];

    return (
        <>
            <Common_Banner
                imgSrc={"/assets/images/common_banners/about_banner.png"}
                title_text="Gallery"
                breadcrumbs={breadcrumbs}
            />
            <section className='gallery-section'>
                <Container>
                    <div className='gallery-header text-center'>
                        <h2 className='gallery-title'>Moments That Inspire Movement</h2>
                        <p className="gallery-subtitle">
                            Experience the energy, dedication, and transformation that define our fitness community.
                        </p>
                    </div>

                    <div className='card-div'>
                        <Row>
                            {galleryImages.map((image) => (
                                <Col key={image.id} md={4} sm={6} xs={6} className="mb-4">
                                    <div className="gallery-card">
                                        <img src={image.src} alt={image.alt} className="gallery-img" />
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </section >
        </>
    )
}

export default Gallery